console.log('google-maps engaged');

let map;

// Fetch img references
let mapRef = document.querySelector('#google-map-container');
let mapMarkerImg = mapRef.getAttribute('locationRef');
let latAtt = Number(mapRef.getAttribute('lat'));
let longAtt = Number(mapRef.getAttribute('long'));

// delete img references
mapRef.removeAttribute('locationRef');

function initMap()
{
	let baseLocation = {
		lat: latAtt,
		lng: longAtt,
	};

	let mapMarker = {
		lat: latAtt,
		lng: longAtt,
	};

	map = new google.maps.Map(document.getElementById('google-map-container'), {
		center: baseLocation,
		minZoom: 13,
		zoom: 14,
		maxZoom: 15,
		styles: [
			{
				elementType: 'geometry',
				stylers: [
					{
						color: '#e2e2e2',
					},
				],
			},
			// {elementType: 'labels.text.stroke', stylers: [{color: '#2C2A2A'}]},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#2C2A2A',
					},
				],
			},
			{
				featureType: 'administrative.locality',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#2C2A2A',
					},
				],
			},
			{
				featureType: 'poi',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit.line',
				elementType: 'all',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'road',
				elementType: 'all',
				stylers: [
					{
						saturation: -100,
					},
					{
						lightness: 45,
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'all',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'all',
				stylers: [
					{
						visibility: 'simplified',
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'road.highway.controlled_access',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'on',
					},
					{
						hue: '#FFFFFF',
					},
					{
						saturation: 100,
					},
				],
			},
			{
				featureType: 'road',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
				],
			},
			{
				featureType: 'road',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#ffffff',
					},
				],
			},
			{
				featureType: 'road',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#9ca5b3',
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [
					{
						color: '#E9E9E9',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [
					{
						color: '#bdbebe',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'all',
				stylers: [
					{
						saturation: -100,
					},
					{
						lightness: 45,
					},
				],
			},
			{
				featureType: 'transit.station.bus',
				elementType: 'all',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit.station.rail',
				elementType: 'all',
				stylers: [
					{
						visibility: 'on',
					},
				],
			},
			{
				featureType: 'transit.station.rail',
				elementType: 'labels.text',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit.station.rail',
				elementType: 'labels.icon',
				stylers: [
					{
						color: '#bdbebe',
					},
					{
						saturation: 100,
					},
				],
			},
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#bdbebe',
					},
				],
			},
			{
				featureType: 'water',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#bdbebe',
					},
				],
			},
			{
				featureType: 'water',
				elementType: 'labels.text.stroke',
				stylers: [
					{
						color: '#C6E8EC',
					},
				],
			},
		],
		mapTypeControl: false,
	});

	let mapMarkerHighlight = {
		url: mapMarkerImg,
		scaledSize: new google.maps.Size(37, 51),
		origin: new google.maps.Point(0, 0), // origin
		anchor: new google.maps.Point(0, 0), // anchor
	};

	let mapMarkerHighlightMarker = new google.maps.Marker({
		position: mapMarker,
		map: map,
		icon: mapMarkerHighlight,
	});
}
